import { Form, Formik } from 'formik'
import { object, date } from 'yup';
import DatepickerContainer from '../../forms/fields/DatepickerContainer'
import { FLYER, NEWSPAPER } from '../../../constants/printType'
import Translation from '../../Translation/cont/Translation'

const ChooseStartEndDate = ({
    printType,

    data,
    initValues,

    printToolAddDatePeriod,
}) => {
    const validationSchema = object().noUnknown({onlyKnownKeys : true}).shape({
        startDate: date().required(),
        endDate: date().required(),
    })

    const onSubmitForm = (values, actions) => {        
        if(printType === FLYER) {
            if((!values.endDate && !values.startDate)) {
                printToolAddDatePeriod(null, data.pk)
            } else{
                printToolAddDatePeriod(values, data.pk)
            }
        } else {
            if((!values.endDate && !values.startDate)) {
                printToolAddDatePeriod(null)
            } else{
                printToolAddDatePeriod(values)
            }
        }
    }

    return (
        <>
            <Formik
                initialValues={initValues}
                validationSchema={validationSchema}
                onSubmit={onSubmitForm}
            >
                {({values, errors, isSubmitting, setFieldValue}) =>
                    <Form>
                        <div className="datepicker-container add-custom-period gap-20">
                            <div className="datepicker-wrapper">
                                <DatepickerContainer
                                    name={"startDate"} 
                                    onChange={setFieldValue}
                                    value={values.startDate}
                                    resetValue={'endDate'}
                                    isStartDate={true}
                                    type="text" 
                                    id="startDate" 
                                    start={values.startDate}
                                    end={values.endDate}
                                />
                                {Object.keys(errors).length != 0 && errors.startDate && <Translation id="formik_field_required">Dieses Feld wird benötigt!</Translation>}
                            </div>

                            <div className="datepicker-wrapper">
                                <DatepickerContainer
                                    name={"endDate"}
                                    onChange={setFieldValue}
                                    value={values.endDate}
                                    end={values.endDate}
                                    start={values.startDate}
                                    type="text" 
                                    id="endDate"
                                />
                                {Object.keys(errors).length != 0 && errors.endDate && <Translation id="formik_field_required">Dieses Feld wird benötigt!</Translation>}
                            </div>
                        </div>

                        <button type="submit" className={"button button-text"} disabled={isSubmitting}>
                            <Translation id="print_flyer_use_custom_date_period"/>
                        </button>
                    </Form>
                }
            </Formik>
        </>
    )

}

export default ChooseStartEndDate